/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  KillswitchLiftRequest,
  KillswitchLiftRequest$Outbound,
  KillswitchLiftRequest$outboundSchema,
} from "../components/killswitchliftrequest.js";

export type KillswitchesLiftSecurity = {
  sessionHeaderGramSession: string;
};

export type KillswitchesLiftRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  killswitchLiftRequest: KillswitchLiftRequest;
};

/** @internal */
export type KillswitchesLiftSecurity$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const KillswitchesLiftSecurity$outboundSchema: z.ZodMiniType<
  KillswitchesLiftSecurity$Outbound,
  KillswitchesLiftSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function killswitchesLiftSecurityToJSON(
  killswitchesLiftSecurity: KillswitchesLiftSecurity,
): string {
  return JSON.stringify(
    KillswitchesLiftSecurity$outboundSchema.parse(killswitchesLiftSecurity),
  );
}

/** @internal */
export type KillswitchesLiftRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  KillswitchLiftRequest: KillswitchLiftRequest$Outbound;
};

/** @internal */
export const KillswitchesLiftRequest$outboundSchema: z.ZodMiniType<
  KillswitchesLiftRequest$Outbound,
  KillswitchesLiftRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    killswitchLiftRequest: KillswitchLiftRequest$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      killswitchLiftRequest: "KillswitchLiftRequest",
    });
  }),
);

export function killswitchesLiftRequestToJSON(
  killswitchesLiftRequest: KillswitchesLiftRequest,
): string {
  return JSON.stringify(
    KillswitchesLiftRequest$outboundSchema.parse(killswitchesLiftRequest),
  );
}
